module.exports = __webpack_public_path__ + "img/farewell_10.64ed3b62.jpg";